
















































































import { createComponent, ref, onMounted, reactive } from '@vue/composition-api'
import { UnwrapRef } from '@vue/composition-api/dist/reactivity'
import { Table, Message } from 'element-ui'
import permissionCheckbox from '@/components/permissionCheckbox.vue'
import { applicantList, ApplicantCmd, applicant, ListApproval } from '@/service/public'
import { getEnv } from '@/helpers/common'
import { envMap, AccessStateLabel, AccessState, FilePower } from '@/constant'
import { isEmpty } from 'lodash'

interface ConditType {
    pageNum: number
    pageSize: number
    total: number
}

export default createComponent({
    components: { permissionCheckbox },
    setup() {
        const envUrl = envMap[getEnv()].hostname
        const tableRef = ref<Table>(void null)
        const permissionCode = ref<string>()
        const checkList = ref<number[]>([])
        const dialogVisible = ref<boolean>(false)
        const formInline: UnwrapRef<{ fileName: string }> = reactive({
            fileName: '',
        })
        const conditions: UnwrapRef<ConditType> = reactive({
            pageNum: 1,
            pageSize: 10,
            total: 0,
        })
        const tableData = ref<ListApproval[]>([])
        const cmd = reactive<ApplicantCmd>({
            permissionCodes: [],
            powers: [],
        })
        const getApplicantList = async (current?: number) => {
            let params = {
                current: current || conditions.pageNum,
                size: conditions.pageSize,
                ...formInline,
            }
            const res = await applicantList(params)
            if (res.code === 0 && res.data) {
                tableData.value = res.data.list || []
                conditions.pageNum = res.data.pageNum
                conditions.pageSize = res.data.pageSize
                conditions.total = res.data.total
            } else {
                tableData.value = []
            }
        }
        const changePageSize = (pageSize: number) => {
            conditions.pageSize = pageSize
            getApplicantList()
        }
        const setCurrentPage = (currentPage: number) => {
            conditions.pageNum = currentPage
            getApplicantList()
        }
        const submit = async () => {
            if (!permissionCode.value) {
                Message.error('请输入权限码')
                return
            }
            if (isEmpty(checkList.value)) {
                Message.error('请选择权限')
                return
            }
            cmd.permissionCodes = (permissionCode.value && permissionCode.value.split(',')) || []
            cmd.powers = checkList.value
            if (!checkList.value.includes(FilePower['PREVIEW'])) checkList.value.push(FilePower['PREVIEW'])
            const res = await applicant({ cmd })
            if (res.code === 0) {
                getApplicantList(1)
            }
            dialogVisible.value = false
        }
        onMounted(getApplicantList)
        return {
            submit,
            checkList,
            permissionCode,
            dialogVisible,
            tableRef,
            formInline,
            conditions,
            tableData,
            changePageSize,
            setCurrentPage,
            getApplicantList,
            envUrl,
            AccessStateLabel,
            AccessState,
        }
    },
})
